var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: '100%', height: '380px'}),attrs:{"id":"myChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }